import {ProteinSpecifier} from 'analyses/aa-sequence-alignment/util/AaSequenceAlignmentConstants';
import {Permissions} from 'auth/PermissionConstants';
import {ProteinSummary, Protein} from 'molbio/aa-sequences/util/AaSequenceConstants';

/**
 * Given a protein model, create a protein specifier (which specifies a row to use in a protein
 * alignment) that specifies that that protein should be used.
 */
export default function specifierForAaSequence(
  protein: (ProteinSummary | Protein) & {permissions: Permissions}
): ProteinSpecifier {
  return {
    id: protein.id,
    name: protein.name,
    canBeTemplate: Boolean(protein.permissions.polymerFeaturesEditable),
  };
}
